import React, { useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import PlayerStatsInputTable from '../../components/dashboard/PlayerStatsInputTable';
import DashboardNavBar from '../../components/dashboard/DashboardNavBar';

const { Content } = Layout;

const PlayerStatsInputPage = () => {
  const location = useLocation();
  const { game } = location.state; // Access the passed game data

  // State to manage navbar collapse
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Sidebar Navigation */}
      <DashboardNavBar
        game={game}
        collapsed={collapsed}
        onToggle={handleToggleCollapsed}
      />

      {/* Main Content */}
      <Layout
        style={{
          marginLeft: collapsed ? '80px' : '250px', // Adjust dynamically based on the collapsed state
          transition: 'margin-left 0.2s ease-in-out', // Smooth transition when toggling sidebar
          backgroundColor: '#fff', // Fix grey background issue
        }}
      >
        <Content
          style={{
            marginTop: '64px', // Offset for top navigation
            padding: '20px',
          }}
        >
          {/* Render the player stats table */}
          <PlayerStatsInputTable gameId={game.id} game={game} />
        </Content>
      </Layout>
    </Layout>
  );
};

export default PlayerStatsInputPage;
